import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import ToolbarBackIcon from '../../Icons/ToolbarBackIcon';
import useViewport, { LOW } from '../Hooks/useViewport';
import { NOOP } from '../../../utils/const';

const cssBlock = 'v2-toolbar';

/**
 * Banda "Breadcumbs" con component Breadcrumbs e bottone di back.
 */
const BreadcrumbsBand = ({ onBack, onSelect, breadcrumbs }) => {
  const { resolution } = useViewport();

  const handleBack = useCallback((evt) => {
    // primo parametro è la penultima breadcrumbs
    onBack(breadcrumbs.length > 1 ? breadcrumbs[breadcrumbs.length - 2] : undefined, evt);
  }, [breadcrumbs, onBack]);

  // dalla risoluzine "tolgo" la lunghezza del component Back Button.
  const maxBreadcrumbsCompWidth = (resolution === LOW ? 732 : 954) - 20 - 12 - 16;

  return (
    <div className={`${cssBlock}__breadcrumbs-band`}>
      {onBack !== NOOP && (
        <Button onClick={handleBack} blockClassName={`${cssBlock}__back`}>
          <ToolbarBackIcon />
        </Button>
      )}
      <Breadcrumbs onSelect={onSelect} breadcrumbs={breadcrumbs} maxWidth={maxBreadcrumbsCompWidth} />
    </div>
  );
};

BreadcrumbsBand.propTypes = {
  onBack: PropTypes.func.isRequired,

  onSelect: PropTypes.func.isRequired,

  breadcrumbs: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.string,
        labe: PropTypes.string,
      }),
    ]),
  ).isRequired,
};

export default BreadcrumbsBand;
